import { render, staticRenderFns } from "./year.vue?vue&type=template&id=a2c9a45a&scoped=true&"
import script from "./year.vue?vue&type=script&lang=js&"
export * from "./year.vue?vue&type=script&lang=js&"
import style0 from "./year.vue?vue&type=style&index=0&id=a2c9a45a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c9a45a",
  null
  
)

export default component.exports